import { Pipe, PipeTransform } from '@angular/core';
import { AutocompleteMarker, DefaultMapMarker } from '../map-utils';
import { AUTOCOMPLETE_MARKER_ID } from '../../constants';

@Pipe({
  name: 'tooltipText',
})
export class TooltipTextPipe implements PipeTransform {

  transform(hoveredMarker: DefaultMapMarker | AutocompleteMarker): string {
    if (!hoveredMarker || hoveredMarker.id === AUTOCOMPLETE_MARKER_ID) {
      return '';
    }

    return (hoveredMarker as DefaultMapMarker).markerLocations
        .map(ml => ml.location.businessName)
        .join(',<br>');
  }

}
